import { render } from "./ContactItem.vue?vue&type=template&id=1c622d47&scoped=true&ts=true"
import script from "./ContactItem.vue?vue&type=script&lang=ts"
export * from "./ContactItem.vue?vue&type=script&lang=ts"

import "./ContactItem.vue?vue&type=style&index=0&id=1c622d47&scoped=true&lang=scss"

import exportComponent from "/Users/aleksandrvasilevic/Documents/Dev/WEB/Pets/phone-book/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c622d47"]])

export default __exports__